<template>
  <div>
    <div class="page-title">Special Collection Archive</div>
    <template v-for="collection in collections" >
      <div class="collection-container">
        <media-container :key="collection.articlesData.ids.pii" :collections-header="true" :issue="collection.articlesData" :figures="collection.articlesData.files.figures"></media-container>
        <h2><router-link :to="{ name: 'collectionDetail', params: { id: collection.id }}">Special Collection on Some Topic</router-link></h2>
        <div class="types">{{collection.articlesTypes.length}} Papers inlcuding: {{collection.articlesTypes.join(', ')}}</div>
        <div class="description">{{collection.description}}</div>
        <div class="text-center hidden-md-up">
          <b-button class="button-secondary my-2 my-sm-0" variant="link" :to="{ name: 'collectionDetail', params: { id: collection.id }}">
            View Collection
          </b-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import MediaContainer from '@/components/shared/MediaContainerComponent'
  export default {
    name: 'collections',
    components: {
      MediaContainer
    },
    data () {
      return {
        collections: []
      }
    },
    created () {
      this.$http.get(this.$store.state.dataUrlIssue).then(function (response) {
        var collection = response.body
        // TODO: replace with data from services and Collections model
        collection['articlesData'] = collection.articles[3]
        collection['articlesData']['caption'] = collection.caption
        collection['description'] = 'Description of the collection goes here dolor sit amet, consectetur adipiscing elit. ' +
          'Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. ' +
          'Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ' +
          'ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.'
        collection['id'] = parseInt(collection.issue)
        collection['articlesTypes'] = collection.articles.map((item) => { return item.article_type.name }).filter(function (item, i, allItems) {
          return i === allItems.indexOf(item)
        })
        this.collections = [collection, collection]
      }, function () {
      })
    }
  }
</script>


<style scoped lang="scss">
  .collection-container {
    margin: 40px 0px;
    padding-bottom: 40px;
    border-bottom: 1px solid $devider;
    h2 {
      a {
        color: $primary-color;
        text-decoration: underline;
        margin-bottom: 20px;
      }
    }
    .description{
      margin: 10px 0px;
    }
    .types {
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      text-align: left;
      color: $primary-color;
      opacity: 0.6;
      margin-bottom: 7.5px;
    }

  }
</style>



// WEBPACK FOOTER //
// CollectionsPage.vue?10441f5d